export default __webpack_public_path__ + "static/media/lorcana_super_rare.854910c6.svg";